var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals},scopedSlots:_vm._u([{key:"ORDERDETAIL",fn:function(ref){
var params = ref.params;
var visible = ref.visible;
return [(visible)?_c('order',{attrs:{"orderDetails":params.dataDetails,"pageText":params.pageText,"footer-hide":false}}):_vm._e()]}},{key:"PREVIEW",fn:function(ref){
var params = ref.params;
var visible = ref.visible;
return [(typeof params.src !== 'undefined')?_c('Carousel',_vm._l((params.src.payload),function(item,k){return _c('CarouselItem',{staticStyle:{"height":"480px","text-align":"center","background-color":"#fff"}},[_c('img',{staticStyle:{"max-height":"480px","max-width":"480px"},attrs:{"src":item,"alt":""}})])}),1):_vm._e()]}},{key:"ORDERTRACKER",fn:function(ref){
var params = ref.params;
var visible = ref.visible;
return [(visible)?_c('order-tracker',{attrs:{"type":"all","statusId":params.id}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }